<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:09:39
 * @Description: 维保建筑查看
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :inline="true"
      label-position="right"
      label-width="150px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑名称"
            prop="jzwmc"
          >
            <span class="c-form__read">{{ fd.jzwmc }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="建筑地址"
            prop="jzdz"
          >
            <span class="c-form__read">{{ fd.jzdz }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑类别"
            prop="jzlbDm"
          >
            <span class="c-form__read">{{ fd.jzlbMc }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="自动消防设备"
            prop="zdxfss"
          >
            <span class="c-form__read">{{ fd.zdxfss === 'Y'? '是':'否' }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="占地面积（m²）"
            prop="zdmj"
          >
            <span class="c-form__read">{{ fd.zdmj }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑面积（m²）"
            prop="jzmj"
          >
            <span class="c-form__read">{{ fd.jzmj }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="楼层数"
            prop="lcs"
          >
            <span class="c-form__read">{{ fd.lcs }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="建筑高度（m）"
            prop="jzgd"
          >
            <span class="c-form__read">{{ fd.jzgd }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地上层层数"
            prop="dscs"
          >
            <span class="c-form__read">{{ fd.dscs }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="地下层层数"
            prop="dxcs"
          >
            <span class="c-form__read">{{ fd.dxcs }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="安全出口数（个）"
            prop="aqcks"
          >
            <span class="c-form__read">{{ fd. aqcks }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="疏散楼梯数（个）"
            prop="sslts"
          >
            <span class="c-form__read">{{ fd.sslts }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="消防电梯数（个）"
            prop="xfdts"
          >
            <span class="c-form__read">{{ fd.xfdts }}</span>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="避难层位置"
            prop="bncwz"
          >
            <span class="c-form__read">{{ fd.bncwz }}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbjzService } from './wbjz.service';

export default {
  name: 'WbjzViewDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示

      /* 表单参数 Start */
      fd: {
        jzwmc: null, // 建筑名称
        jzdz: null, // 建筑地址
        jzlbDm: null, // 建筑类别
        jzlbMc: null,
        zdmj: null, // 占地面积
        zdxfss: null, // 自动消防设备
        jzmj: null, // 建筑面积
        lcs: null, // 楼层数
        jzgd: null, // 建筑高度
        dscs: null, // 地上层层数
        dxcs: null, // 底下层层数
        aqcks: null, // 安全出口数
        sslts: null, // 疏散楼梯数
        xfdts: null, // 消防电梯数
        bncwz: null // 避难层位置
      }
      /* 表单参数 End */

    };
  },
  computed: {
  },
  methods: {
    /**
     * @description: 初始化维保建筑信息
     * @return {*}
     */
    init () {
      this.loading = true;
      wbjzService.getInfo(this.dlParams.id)
        .then(rsp => {
          this.fd = Object.assign({}, this.fd, rsp.data);
        })
        .catch(err => {
          console.error('获取职位信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        this.loading = true;
        if (valid) {
          if (this.dlType === 'add') {
            this.addSave();
          } else {
            this.updateSave();
          }
        }
      });
    },
    /**
     * @description: 新增保存服务
     * @return {*}
     */
    addSave () {
      wbjzService.save(this.fd)
        .then(rsp => {
          this.$alert('新增成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('新增建筑错误！', err);
          this.loading = false;
        });
    },
    /**
     * @description: 修改保存
     * @return {*}
     */
    updateSave () {
      wbjzService.update(this.dlParams.id, this.fd)
        .then(rsp => {
          this.$alert('修改成功！', '提示', {
            confirmButtonText: '确定',
            type: 'success',
            callback: action => {
            }
          });
          this.$emit('closeDialog', '');
          this.$emit('callback');
        })
        .catch(err => {
          console.error('修改建筑错误！', err);
          this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    if (this.dlParams.id) {
      this.init();
    }
  }
};
</script>
